import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/img/zeronine.png';
import { Image } from '@chakra-ui/react';

const Footer = () => {
   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
   const [currentPage, setCurrentPage] = useState('home');
   const [aiAssistantOpen, setAiAssistantOpen] = useState(false);

   const navigateTo = (page) => {
      setCurrentPage(page);
      setMobileMenuOpen(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
   };

   const scrollToSection = (section) => {
      setMobileMenuOpen(false);
      if (currentPage !== 'home') {
         setCurrentPage('home');
         setTimeout(() => {
            document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
         }, 100);
      } else {
         document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
      }
   };

   return (
      <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-20 px-4">
         <style>{`
            .footer-link {
               position: relative;
               display: inline-block;
            }
            
            .footer-link::after {
               content: '';
               position: absolute;
               width: 0;
               height: 2px;
               bottom: -2px;
               left: 0;
               background: linear-gradient(90deg, #3b82f6, #8b5cf6);
               transition: width 0.3s ease;
            }
            
            .footer-link:hover::after {
               width: 100%;
            }
            
            .footer-link:hover {
               color: white;
               transform: translateX(4px);
            }
         `}</style>

         <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-4 gap-12 mb-16">
               <div>
                  <div className="flex items-center gap-3 mb-6">
                     <Image src={Logo} alt="ZeroNine Logo" width={'200px'} />
                  </div>
                  <p className="text-gray-400 mb-6 leading-relaxed">
                     India's most intelligent accounting software powered by AI
                  </p>
                  <div className="flex gap-3">
                     {['f', 'tw', 'in', 'yt'].map((social, idx) => (
                        <button
                           key={idx}
                           className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-xl flex items-center justify-center transition-all transform hover:scale-110">
                           <span className="text-sm font-bold">{social}</span>
                        </button>
                     ))}
                  </div>
               </div>

               <div>
                  <h5 className="font-black mb-6 text-lg">AI Products</h5>
                  <ul className="space-y-3 text-gray-400">
                     <li>
                        <button
                           onClick={() => scrollToSection('features')}
                           className="footer-link transition-all duration-300">
                           AI Features
                        </button>
                     </li>
                     <li>
                        <button
                           onClick={() => scrollToSection('pricing')}
                           className="footer-link transition-all duration-300">
                           Pricing
                        </button>
                     </li>
                     <li>
                        <a href="#" className="footer-link transition-all duration-300">
                           Mobile AI App
                        </a>
                     </li>
                     <li>
                        <a href="#" className="footer-link transition-all duration-300">
                           AI Integrations
                        </a>
                     </li>
                     <li>
                        <a href="#" className="footer-link transition-all duration-300">
                           AI API Docs
                        </a>
                     </li>
                  </ul>
               </div>

               <div>
                  <h5 className="font-black mb-6 text-lg">Legal</h5>
                  <ul className="space-y-3 text-gray-400">
                     <li>
                        <Link to={'/termsofservice'} className="footer-link transition-all duration-300">
                           Terms of Service
                        </Link>
                     </li>
                     <li>
                        <Link to={'/privacypolicy'} className="footer-link transition-all duration-300">
                           Privacy Policy
                        </Link>
                     </li>
                     <li>
                        <Link to={'/refundpolicy'} className="footer-link transition-all duration-300">
                           Refund & Cancellation Policy
                        </Link>
                     </li>
                     <li>
                        <Link to={'/helpsupport'} className="footer-link transition-all duration-300">
                           Help & Support
                        </Link>
                     </li>
                  </ul>
               </div>

               <div>
                  <h5 className="font-black mb-6 text-lg">Company</h5>
                  <ul className="space-y-3 text-gray-400">
                     <li>
                        <button onClick={() => navigateTo('about')} className="footer-link transition-all duration-300">
                           About Us
                        </button>
                     </li>
                     <li>
                        <a href="#" className="footer-link transition-all duration-300">
                           AI Careers
                        </a>
                     </li>
                     <li>
                        <a href="#" className="footer-link transition-all duration-300">
                           AI Blog
                        </a>
                     </li>
                     <li>
                        <a href="#" className="footer-link transition-all duration-300">
                           Press Kit
                        </a>
                     </li>
                     <li>
                        <a href="#" className="footer-link transition-all duration-300">
                           AI Partners
                        </a>
                     </li>
                  </ul>
               </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-800 text-center pb-5">
               <p className="text-gray-500 text-lg">Copyright © {new Date().getFullYear()} Zeronine Pvt. Ltd.</p>
            </div>
         </div>
      </footer>
   );
};

export default Footer;
